import { BOTTOM_PADDING_PER_ITEM, SCROLL_OFFSET } from './constants';
import { AnchorItem } from './types';

// Helper: Get all anchor hrefs including nested children
export const getAllAnchorHrefs = (items: AnchorItem[]): string[] => {
  const hrefs: string[] = [];
  items.forEach((item) => {
    if (item.href) {
      hrefs.push(item.href);
    }
    if (item.children) {
      item.children.forEach((child) => {
        if (child.href) {
          hrefs.push(child.href);
        }
      });
    }
  });
  return hrefs;
};

// Helper: Check if href is a child item
export const isChildItem = (
  anchorItems: AnchorItem[],
  href: string
): boolean => {
  return anchorItems.some((item) =>
    item.children?.some((child) => child.href === href)
  );
};

// Helper: Calculate scroll position for an element (same as click handler)
export const calculateScrollPosition = (
  elementTop: number,
  containerTop: number,
  currentScrollTop: number,
  containerPaddingTop: number = 0
): number => {
  // Account for container's top padding when calculating scroll position
  return (
    currentScrollTop +
    (elementTop - containerTop) -
    SCROLL_OFFSET -
    containerPaddingTop
  );
};

export const calculateBottomPadding = (
  allHrefs: string[],
  contentWrapperRef: React.RefObject<HTMLDivElement>
) => {
  // Get the last anchor item (the one that needs padding)
  const lastHref = allHrefs[allHrefs.length - 1];
  if (!lastHref) return;

  const lastItemElement = contentWrapperRef.current?.querySelector(lastHref);
  if (!(lastItemElement instanceof HTMLElement)) return;

  // Get scroll container
  const scrollContainer =
    contentWrapperRef.current?.closest('.ant-drawer-body');
  if (!(scrollContainer instanceof HTMLElement)) return;

  // Measure the last item's dimensions and position
  const lastItemRect = lastItemElement.getBoundingClientRect();
  const lastItemHeight = lastItemRect.height;

  // Ensure minimum padding: at least the item height + offset + buffer
  // This ensures the item can be fully scrolled into view regardless of its current position
  const finalPadding =
    window.innerHeight - lastItemHeight - BOTTOM_PADDING_PER_ITEM;

  return Math.max(finalPadding, 0);
};

/**
 * Update browser URL hash
 */
export const updateUrlHash = (href: string): void => {
  window.history.replaceState({}, '', href);
};
